module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5dpvs"))).then(() => module.bundle.root('iDabs'));